import { css } from '@emotion/react'
import { styled } from 'styles/styled'
import { theme } from 'styles/theme'

interface DesktopDisciplineContentContainerProps {
  $isVisible?: boolean
  $maxWidth?: number
}

export const DesktopDisciplineContentContainer = styled.div<DesktopDisciplineContentContainerProps>`
  border-radius: 12px;
  position: absolute;
  top: 40px;
  left: 6px;
  background-color: white;
  width: max-content;
  max-width: ${({ $maxWidth = 700 }) => `${Math.min($maxWidth, 700)}px`};
  height: 300px;
  z-index: 92;
  overflow: hidden;
  display: flex;
  ${({ $isVisible }) => {
    if (!$isVisible)
      return css`
        display: none;
      `
  }};
`

export const Level1CategoriesContainer = styled.div`
  height: 100%;
  width: 216px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
interface Level1CategoriesButtonProps {
  $isSelected?: boolean
}

export const Level1CategoriesButton = styled.button<Level1CategoriesButtonProps>`
  padding: 0 20px;
  background-color: white;
  flex-grow: 1;
  flex-shrink: 0;
  border: 1px solid ${theme.palette.surface.secondary};
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: ${theme.palette.surface.secondary};
    `};
`

export const SecondColumnContainer = styled.div`
  max-height: 100%;
  overflow-y: auto;
  width: 62%;
`

export const Level2CategoriesContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-content: flex-start;
  gap: 6px;
  overflow: hidden;
`

export const Level2CategoriesTitleContainer = styled.div`
  margin-bottom: 12px;
`
